export const isErrorDispatch = async (func: any) => {
  const resp = await func;
  if (resp.hasOwnProperty('error')) {
    throw new Error(JSON.stringify(resp.payload));
  } else {
    return resp;
  }
};
